import { CategoriesFe } from "src/app/features/items/components/items-module/categories-tab/categories.models";
import { ComponentsFe } from "src/app/features/items/components/items-module/components-tab/components.models";
import { DepartmentsFe } from "src/app/features/items/components/items-module/departments-tab/departments.model";
import { RawMaterialsFe } from "src/app/features/items/components/items-module/raw-materials-tab/raw-materials.model";
import { VatRatesFe } from "src/app/features/items/components/items-module/vat-rates-tab/vat-rates-model";
import { StockFe } from "src/app/features/stock/stock-management/model/stock-model";
import { StockMovementDetailFe, StockMovementSearchFe, StockMovementsFe } from "src/app/features/stock/stock-movements/models/stock-movements.model";
import { ItemFe } from "src/app/shared/model/model";

const customers_showcase = new Map<string, string>([
    ["avg_spent", "CUSTOMERS.SHOWCASE.AVG_SPENT"],
    ["billing_city", "CUSTOMERS.SHOWCASE.BILLING_CITY"],
    ["billing_country", "CUSTOMERS.SHOWCASE.BILLING_COUNTRY"],
    ["billing_number", "CUSTOMERS.SHOWCASE.BILLING_NUMBER"],
    ["billing_prov", "CUSTOMERS.SHOWCASE.BILLING_PROV"],
    ["billing_street", "CUSTOMERS.SHOWCASE.BILLING_STREET"],
    ["billing_zip", "CUSTOMERS.SHOWCASE.BILLING_ZIP"],
    ["birthdate", "CUSTOMERS.SHOWCASE.BIRTHDATE"],
    ["company_name", "CUSTOMERS.SHOWCASE.COMPANY_NAME"],
    ["created_at", "CUSTOMERS.SHOWCASE.CREATED_AT"],
    ["createdby_id", "CUSTOMERS.SHOWCASE.CREATEDBY_ID"],
    ["credit", "CUSTOMERS.SHOWCASE.CREDIT"],
    ["custom_1", "-s customers.custom_field_1"],
    ["custom_2", "-s customers.custom_field_2"],
    ["custom_3", "-s customers.custom_field_3"],
    ["custom_4", "-s customers.custom_field_4"],
    ["custom_5", "-s customers.custom_field_5"],
    ["custom_6", "-s customers.custom_field_6"],
    ["custom_7", "-s customers.custom_field_7"],
    ["custom_8", "-s customers.custom_field_8"],
    ["custom_9", "-s customers.custom_field_9"],
    ["custom_type", "CUSTOMERS.SHOWCASE.CUSTOM_TYPE"],
    ["default_pricelist", "CUSTOMERS.SHOWCASE.DEFAULT_PRICELIST"],
    ["disable_mail_receipts", "CUSTOMERS.SHOWCASE.DISABLE_MAIL_RECEIPTS"],
    ["discount_perc", "CUSTOMERS.SHOWCASE.DISCOUNT_PERC"],
    ["email", "CUSTOMERS.SHOWCASE.EMAIL"],
    ["email_pec", "CUSTOMERS.SHOWCASE.EMAIL_PEC"],
    ["external_id", "CUSTOMERS.SHOWCASE.EXTERNAL_ID"],
    ["facebook", "CUSTOMERS.SHOWCASE.FACEBOOK"],
    ["fidelity", "CUSTOMERS.SHOWCASE.FIDELITY"],
    ["first_name", "CUSTOMERS.SHOWCASE.FIRST_NAME"],
    ["gender", "CUSTOMERS.SHOWCASE.GENDER"],
    ["id", "CUSTOMERS.SHOWCASE.ID"],
    ["instagram", "CUSTOMERS.SHOWCASE.INSTAGRAM"],
    ["last_name", "CUSTOMERS.SHOWCASE.LAST_NAME"],
    ["linkedin", "CUSTOMERS.SHOWCASE.LINKEDIN"],
    ["lottery_code", "CUSTOMERS.SHOWCASE.LOTTERY_CODE"],
    ["mobile", "CUSTOMERS.SHOWCASE.MOBILE"],
    ["notes", "CUSTOMERS.SHOWCASE.NOTES"],
    ["payments_allowed", "CUSTOMERS.SHOWCASE.PAYMENTS_ALLOWED"],
    ["phone", "CUSTOMERS.SHOWCASE.PHONE"],
    ["sales_count", "CUSTOMERS.SHOWCASE.SALES_COUNT"],
    ["sdi_code", "CUSTOMERS.SHOWCASE.SDI_CODE"],
    ["send_commercials", "CUSTOMERS.SHOWCASE.SEND_COMMERCIALS"],
    ["shipping_city", "CUSTOMERS.SHOWCASE.SHIPPING_CITY"],
    ["shipping_country", "CUSTOMERS.SHOWCASE.SHIPPING_COUNTRY"],
    ["shipping_number", "CUSTOMERS.SHOWCASE.SHIPPING_NUMBER"],
    ["shipping_prov", "CUSTOMERS.SHOWCASE.SHIPPING_PROV"],
    ["shipping_street", "CUSTOMERS.SHOWCASE.SHIPPING_STREET"],
    ["shipping_zip", "CUSTOMERS.SHOWCASE.SHIPPING_ZIP"],
    ["shipping_city_1", "CUSTOMERS.SHOWCASE.SHIPPING_CITY_1"],
    ["shipping_country_1", "CUSTOMERS.SHOWCASE.SHIPPING_COUNTRY_1"],
    ["shipping_number_1", "CUSTOMERS.SHOWCASE.SHIPPING_NUMBER_1"],
    ["shipping_prov_1", "CUSTOMERS.SHOWCASE.SHIPPING_PROV_1"],
    ["shipping_street_1", "CUSTOMERS.SHOWCASE.SHIPPING_STREET_1"],
    ["shipping_zip_1", "CUSTOMERS.SHOWCASE.SHIPPING_ZIP_1"],
    ["shipping_city_2", "CUSTOMERS.SHOWCASE.SHIPPING_CITY_2"],
    ["shipping_country_2", "CUSTOMERS.SHOWCASE.SHIPPING_COUNTRY_2"],
    ["shipping_number_2", "CUSTOMERS.SHOWCASE.SHIPPING_NUMBER_2"],
    ["shipping_prov_2", "CUSTOMERS.SHOWCASE.SHIPPING_PROV_2"],
    ["shipping_street_2", "CUSTOMERS.SHOWCASE.SHIPPING_STREET_2"],
    ["shipping_zip_2", "CUSTOMERS.SHOWCASE.SHIPPING_ZIP_2"],
    ["shipping_city_3", "CUSTOMERS.SHOWCASE.SHIPPING_CITY_3"],
    ["shipping_country_3", "CUSTOMERS.SHOWCASE.SHIPPING_COUNTRY_3"],
    ["shipping_number_3", "CUSTOMERS.SHOWCASE.SHIPPING_NUMBER_3"],
    ["shipping_prov_3", "CUSTOMERS.SHOWCASE.SHIPPING_PROV_3"],
    ["shipping_street_3", "CUSTOMERS.SHOWCASE.SHIPPING_STREET_3"],
    ["shipping_zip_3", "CUSTOMERS.SHOWCASE.SHIPPING_ZIP_3"],
    ["shipping_city_4", "CUSTOMERS.SHOWCASE.SHIPPING_CITY_4"],
    ["shipping_country_4", "CUSTOMERS.SHOWCASE.SHIPPING_COUNTRY_4"],
    ["shipping_number_4", "CUSTOMERS.SHOWCASE.SHIPPING_NUMBER_4"],
    ["shipping_prov_4", "CUSTOMERS.SHOWCASE.SHIPPING_PROV_4"],
    ["shipping_street_4", "CUSTOMERS.SHOWCASE.SHIPPING_STREET_4"],
    ["shipping_zip_4", "CUSTOMERS.SHOWCASE.SHIPPING_ZIP_4"],
    ["shipping_city_5", "CUSTOMERS.SHOWCASE.SHIPPING_CITY_5"],
    ["shipping_country_5", "CUSTOMERS.SHOWCASE.SHIPPING_COUNTRY_5"],
    ["shipping_number_5", "CUSTOMERS.SHOWCASE.SHIPPING_NUMBER_5"],
    ["shipping_prov_5", "CUSTOMERS.SHOWCASE.SHIPPING_PROV_5"],
    ["shipping_street_5", "CUSTOMERS.SHOWCASE.SHIPPING_STREET_5"],
    ["shipping_zip_5", "CUSTOMERS.SHOWCASE.SHIPPING_ZIP_5"],
    ["shipping_city_6", "CUSTOMERS.SHOWCASE.SHIPPING_CITY_6"],
    ["shipping_country_6", "CUSTOMERS.SHOWCASE.SHIPPING_COUNTRY_6"],
    ["shipping_number_6", "CUSTOMERS.SHOWCASE.SHIPPING_NUMBER_6"],
    ["shipping_prov_6", "CUSTOMERS.SHOWCASE.SHIPPING_PROV_6"],
    ["shipping_street_6", "CUSTOMERS.SHOWCASE.SHIPPING_STREET_6"],
    ["shipping_zip_6", "CUSTOMERS.SHOWCASE.SHIPPING_ZIP_6"],
    ["shipping_city_7", "CUSTOMERS.SHOWCASE.SHIPPING_CITY_7"],
    ["shipping_country_7", "CUSTOMERS.SHOWCASE.SHIPPING_COUNTRY_7"],
    ["shipping_number_7", "CUSTOMERS.SHOWCASE.SHIPPING_NUMBER_7"],
    ["shipping_prov_7", "CUSTOMERS.SHOWCASE.SHIPPING_PROV_7"],
    ["shipping_street_7", "CUSTOMERS.SHOWCASE.SHIPPING_STREET_7"],
    ["shipping_zip_7", "CUSTOMERS.SHOWCASE.SHIPPING_ZIP_7"],
    ["shipping_city_8", "CUSTOMERS.SHOWCASE.SHIPPING_CITY_8"],
    ["shipping_country_8", "CUSTOMERS.SHOWCASE.SHIPPING_COUNTRY_8"],
    ["shipping_number_8", "CUSTOMERS.SHOWCASE.SHIPPING_NUMBER_8"],
    ["shipping_prov_8", "CUSTOMERS.SHOWCASE.SHIPPING_PROV_8"],
    ["shipping_street_8", "CUSTOMERS.SHOWCASE.SHIPPING_STREET_8"],
    ["shipping_zip_8", "CUSTOMERS.SHOWCASE.SHIPPING_ZIP_8"],
    ["shipping_city_9", "CUSTOMERS.SHOWCASE.SHIPPING_CITY_9"],
    ["shipping_country_9", "CUSTOMERS.SHOWCASE.SHIPPING_COUNTRY_9"],
    ["shipping_number_9", "CUSTOMERS.SHOWCASE.SHIPPING_NUMBER_9"],
    ["shipping_prov_9", "CUSTOMERS.SHOWCASE.SHIPPING_PROV_9"],
    ["shipping_street_9", "CUSTOMERS.SHOWCASE.SHIPPING_STREET_9"],
    ["shipping_zip_9", "CUSTOMERS.SHOWCASE.SHIPPING_ZIP_9"],
    ["source_channel", "CUSTOMERS.SHOWCASE.SOURCE_CHANNEL"],
    ["source_store", "CUSTOMERS.SHOWCASE.SOURCE_STORE"],
    ["tax_code", "CUSTOMERS.SHOWCASE.TAX_CODE"],
    ["tot_spent", "CUSTOMERS.SHOWCASE.TOT_SPENT"],
    ["twitter", "CUSTOMERS.SHOWCASE.TWITTER"],
    ["updated_at", "CUSTOMERS.SHOWCASE.UPDATED_AT"],
    ["updatedby_id", "CUSTOMERS.SHOWCASE.UPDATEDBY_ID"],
    ["uuid", "CUSTOMERS.SHOWCASE.UUID"],
    ["vat_code", "CUSTOMERS.SHOWCASE.VAT_CODE"],
    ["Actions", "CUSTOMERS.SHOWCASE.ACTIONS.TITLE"]
]);

const customers_prepaid = new Map<string, string>([
    ["Actions", "CUSTOMERS.DETAILS.CREDIT.GRID.TYPE"],
    ['valid_from','CUSTOMERS.DETAILS.CREDIT.GRID.DATE'],
    ['amount','CUSTOMERS.DETAILS.CREDIT.GRID.AMOUNT'],
    ['credit','CUSTOMERS.DETAILS.CREDIT.GRID.BALANCE'],
    ['shop_uuid','CUSTOMERS.DETAILS.CREDIT.GRID.SHOP'],
]);

const customers_fidelity = new Map<string, string>([
    ["Actions", "CUSTOMERS.DETAILS.POINTS.GRID.TYPE"],
    ["date", "CUSTOMERS.DETAILS.POINTS.GRID.DATE"],
    ["points","CUSTOMERS.DETAILS.POINTS.GRID.POINTS"],
    ["rule_name","CUSTOMERS.DETAILS.POINTS.GRID.RULE"],
    ["shop_name", "CUSTOMERS.DETAILS.POINTS.GRID.SHOP"],
    ["campaign_name", "CUSTOMERS.DETAILS.POINTS.GRID.CAMPAIGN"],
]);

const suppliers_showcase = new Map<string, string>([
    ["name", "SUPPLIERS.SHOWCASE.COMPANY_NAME"],
    ["address_street", "SUPPLIERS.SHOWCASE.STREET_NAME"],
    ["address_number", "SUPPLIERS.SHOWCASE.STREET_NUMBER"],
    ["address_city", "SUPPLIERS.SHOWCASE.CITY"],
    ["address_zip", "SUPPLIERS.SHOWCASE.ZIP_CODE"],
    ["address_prov", "SUPPLIERS.SHOWCASE.COUNTY"],
    ["country", "SUPPLIERS.SHOWCASE.COUNTRY"],
    ["conto_vendita", "SUPPLIERS.DETAILS.CONSIGNMENT"],
    ["phone1", "SUPPLIERS.SHOWCASE.TELEPHONE_1"],
    ["phone2", "SUPPLIERS.SHOWCASE.TELEPHONE_2"],
    ["fax", "SUPPLIERS.SHOWCASE.FAX"],
    ["email1", "SUPPLIERS.SHOWCASE.EMAIL_1"],
    ["email2", "SUPPLIERS.SHOWCASE.EMAIL_2"],
    ["email_pec", "SUPPLIERS.SHOWCASE.EMAIL_PEC"],
    ["website", "SUPPLIERS.SHOWCASE.WEBSITE"],
    ["vat_code", "SUPPLIERS.SHOWCASE.VAT_CODE_NEW"],
    ["notes", "SUPPLIERS.SHOWCASE.NOTE"],
    ["id", "SUPPLIERS.SHOWCASE.ID"],
    ["created_at", "SUPPLIERS.SHOWCASE.CREATED_AT"],
    ["createdby_id", "SUPPLIERS.SHOWCASE.CREATEDBY_ID"],
    ["updated_at", "SUPPLIERS.SHOWCASE.UPDATED_AT"],
    ["updatedby_id", "SUPPLIERS.SHOWCASE.UPDATEDBY_ID"],
    ["Actions", "SUPPLIERS.SHOWCASE.ACTIONS.TITLE"]
]);

const history_sales_showcase = new Map<string, string>([
    ["id", "HISTORY.SALES.SHOWCASE.ID"],
    ["closed_at", "HISTORY.SALES.SHOWCASE.CLOSED_AT"],
    ["sale_number", "HISTORY.SALES.SHOWCASE.SALE_NUMBER"],
    ["is_summary", "HISTORY.SALES.SHOWCASE.IS_SUMMARY"],
    ["summary_emitted", "HISTORY.SALES.SHOWCASE.SUMMARY_EMITTED"],
    ["final_amount", "HISTORY.SALES.SHOWCASE.FINAL_AMOUNT"],
    ["channel", "HISTORY.SALES.SHOWCASE.CHANNEL"],
    ["seller_name", "HISTORY.SALES.SHOWCASE.SELLER_NAME"],
    ["customer_name", "HISTORY.SALES.SHOWCASE.CUSTOMER_NAME"],
    ["change", "HISTORY.SALES.SHOWCASE.CHANGE"],
    ["covers", "HISTORY.SALES.SHOWCASE.COVERS"],
    ["external_id", "HISTORY.SALES.SHOWCASE.EXTERNAL_ID"],
    ["name", "HISTORY.SALES.SHOWCASE.NAME"],
    ["notes", "HISTORY.SALES.SHOWCASE.NOTES"],
    ["open_at", "HISTORY.SALES.SHOWCASE.OPEN_AT"],
    ["printed_prebills", "HISTORY.SALES.SHOWCASE.PRINTED_PREBILLS"],
    ["sale_parent_uuid", "HISTORY.SALES.SHOWCASE.SALE_PARENT_UUID"],
    ["seller_id", "HISTORY.SALES.SHOWCASE.SELLER_ID"],
    ["type_document", "HISTORY.SALES.SHOWCASE.TYPE_DOCUMENT"],
    ["printer", "HISTORY.SALES.SHOWCASE.PRINTER"],
    ["uuid", "HISTORY.SALES.SHOWCASE.UUID"],
    ["payment_type", "HISTORY.SALES.SHOWCASE.PAYMENT_TYPE"],
    ["sequential_number", "HISTORY.SALES.SHOWCASE.SEQUENTIAL_NUMBER"],
    ['room_name', "HISTORY.SALES.SHOWCASE.ROOM_NAME"],
    ['table_name', 'HISTORY.SALES.SHOWCASE.TABLE_NAME'],
    ["Actions", "HISTORY.SALES.SHOWCASE.ACTIONS.TITLE"]
]);

const history_sales_data_sent_showcase = new Map<string, string>([
    ["closed_at", "HISTORY.SALES_DATA_SENT.SHOWCASE.CLOSED_AT"],
    ["sale_data_sent.0.created_at", "HISTORY.SALES_DATA_SENT.SHOWCASE.CREATED_AT"],
    ["name", "HISTORY.SALES_DATA_SENT.SHOWCASE.NAME"],
    ["final_amount", "HISTORY.SALES_DATA_SENT.SHOWCASE.FINAL_AMOUNT"],
    ["sale_data_sent.0.entity", "HISTORY.SALES_DATA_SENT.SHOWCASE.ENTITY"],
    ["sale_data_sent.0.status", "HISTORY.SALES_DATA_SENT.SHOWCASE.STATUS"],
    ["sale_data_sent.0.reason_failed", "HISTORY.SALES_DATA_SENT.SHOWCASE.REASON_FAILED"],
    ["sale_data_sent.0.id", "HISTORY.SALES_DATA_SENT.SHOWCASE.ID"],
    ["sale_data_sent.0.uuid", "HISTORY.SALES_DATA_SENT.SHOWCASE.UUID"],
    ["sale_data_sent.0.retry", "HISTORY.SALES_DATA_SENT.SHOWCASE.RETRY"],
    ["id", "HISTORY.SALES_DATA_SENT.SHOWCASE.SALE_ID"],
    ["sale_data_sent.0.updated_at", "HISTORY.SALES_DATA_SENT.SHOWCASE.UPDATED_AT"],
    ["Actions", "HISTORY.SALES_DATA_SENT.SHOWCASE.ACTIONS.TITLE"]
]);

const history_e_invoices_showcase = new Map<string, string>([
    ["e_invoice_number", "HISTORY.E_INVOICE.SHOWCASE.E_INVOICE_NUMBER"],
    ["customer_name", "HISTORY.E_INVOICE.SHOWCASE.CUSTOMER_NAME"],
    ["final_amount", "HISTORY.E_INVOICE.SHOWCASE.FINAL_AMOUNT"],
    ["closed_at", "HISTORY.E_INVOICE.SHOWCASE.CLOSED_AT"],    
    ["status", "HISTORY.E_INVOICE.SHOWCASE.STATUS"],
    ["Actions", "HISTORY.E_INVOICE.SHOWCASE.ACTIONS.TITLE"]
]);

const giftcard_showcase = new Map<string, string>([
    ["uuid", "GIFTCARD.SHOWCASE.UUID"],
    ["type_uuid", "GIFTCARD.SHOWCASE.TYPE_UUID"],
    ["type_name", "GIFTCARD.SHOWCASE.TYPE_NAME"],
    ["type_description", "GIFTCARD.SHOWCASE.TYPE_DESCRIPTION"],
    ["currency", "GIFTCARD.SHOWCASE.CURRENCY"],
    ["notes", "GIFTCARD.SHOWCASE.NOTES"],
    ["origin_environment", "GIFTCARD.SHOWCASE.ORIGIN_ENVIRONMENT"],
    ["origin_sale", "GIFTCARD.SHOWCASE.ORIGIN_SALE"],
    ["created_by", "GIFTCARD.SHOWCASE.CREATED_BY"],
    ["created_at", "GIFTCARD.SHOWCASE.CREATED_AT"],
    ["updated_by", "GIFTCARD.SHOWCASE.UPDATED_BY"],
    ["updated_at", "GIFTCARD.SHOWCASE.UPDATED_AT"],
    ["deleted_by", "GIFTCARD.SHOWCASE.DELETED_BY"],
    ["deleted_at", "GIFTCARD.SHOWCASE.DELETED_AT"],
    ["code", "GIFTCARD.SHOWCASE.CODE"],
    ["initial_value", "GIFTCARD.SHOWCASE.INITIAL_VALUE"],
    ["last_value", "GIFTCARD.SHOWCASE.LAST_VALUE"],
    ["is_divisible", "GIFTCARD.SHOWCASE.IS_DIVISIBLE"],
    ["valid_since", "GIFTCARD.SHOWCASE.VALID_SINCE"],
    ["valid_until", "GIFTCARD.SHOWCASE.VALID_UNTIL"],
    ["active", "GIFTCARD.SHOWCASE.ACTIVE"],
    ["Actions", "GIFTCARD.SHOWCASE.ACTIONS"]
]);

const settings_um_static_token = new Map<string, string>([
    ['trunc_token','SETTINGS.USERS_MANAGEMENT.TABLE_STATIC_TOKEN.TOKEN'],
    ['description','SETTINGS.USERS_MANAGEMENT.TABLE_STATIC_TOKEN.DESCRIPTION'],
    ['client_id','SETTINGS.USERS_MANAGEMENT.TABLE_STATIC_TOKEN.PERMISSIONS'],
    ['created_at','SETTINGS.USERS_MANAGEMENT.TABLE_STATIC_TOKEN.CREATION_DATE'],
    ['username','SETTINGS.USERS_MANAGEMENT.TABLE_STATIC_TOKEN.CREATED_BY'],
    ["Actions", "SETTINGS.USERS_MANAGEMENT.TABLE_STATIC_TOKEN.ACTIONS.TITLE"]
]);

const history_cash_movements = new Map<string, string>([
    ['id', "HISTORY.CASH_MOVEMENTS.ID"],
    ['description', "HISTORY.CASH_MOVEMENTS.DESCRIPTION"],
    ['movement_type', "HISTORY.CASH_MOVEMENTS.TYPE"],
    ['date', "HISTORY.CASH_MOVEMENTS.DATE"],
    ['amount', "HISTORY.CASH_MOVEMENTS.AMOUNT"],
    ['movement_account', "HISTORY.CASH_MOVEMENTS.ACCOUNT"],
    ['payment_method_name', "HISTORY.CASH_MOVEMENTS.PAYMENT_METHOD_NAME"],
    ['sale_id', "HISTORY.CASH_MOVEMENTS.SALE_ID"],
    ["Actions", "HISTORY.CASH_MOVEMENTS.ACTIONS.TITLE"]
]);
const promotions_showcase = new Map<string, string>([
    ['status', 'PROMOTIONS.SHOWCASE.STATUS'],
    ['name', 'PROMOTIONS.SHOWCASE.NAME'],
    ['items', 'PROMOTIONS.SHOWCASE.ITEMS'],
    ['startData', 'PROMOTIONS.SHOWCASE.START_DATA'],
    ['endData', 'PROMOTIONS.SHOWCASE.END_DATA'],
    ['startTime', 'PROMOTIONS.SHOWCASE.START_TIME'],
    ['endTime', 'PROMOTIONS.SHOWCASE.END_TIME'],
    ['weekDays', 'PROMOTIONS.SHOWCASE.WEEKDAYS'],
    ['fidelity_rule', 'PROMOTIONS.SHOWCASE.FIDELITY_RULE'],
    ['customer_type', 'PROMOTIONS.SHOWCASE.CUSTOMER_TYPE'],
    ['Actions', 'PROMOTIONS.SHOWCASE.ACTIONS'],
]);

const file_importer = new Map<string, string>([
    ['status', "FILE_IMPORTER.SHOWCASE.STATUS"],
    ['name', "FILE_IMPORTER.SHOWCASE.NAME"],
    ['dateToProcess', "FILE_IMPORTER.SHOWCASE.DATE_TIME"],
    ['typeInsert', "FILE_IMPORTER.SHOWCASE.TYPE"],
    ['totalRows', "FILE_IMPORTER.SHOWCASE.ELEMENTS"],
    ['rowsProcessed', "FILE_IMPORTER.SHOWCASE.IMPORTED"],
    ['totalErrors', "FILE_IMPORTER.SHOWCASE.ERRORS"],
    ["Actions", "HISTORY.CASH_MOVEMENTS.ACTIONS.TITLE"]
])

const file_exporter = new Map<string, string>([
    ["status", "FILE_EXPORTER.SHOWCASE.STATUS"],
    ["created_at", "FILE_EXPORTER.SHOWCASE.EXECUTION"],
    ["table", "FILE_EXPORTER.SHOWCASE.TYPE"],
    ["Actions", "HISTORY.CASH_MOVEMENTS.ACTIONS.TITLE"]
])

const history_products_deleted = new Map<string, string>([
    ["sale_item_deleted_at", "HISTORY.PRODUCTS_DELETED.SALE_ITEM_DELETED_AT"],
    ["sale_id", "HISTORY.PRODUCTS_DELETED.SALE_ID"],
    ["sale_name", "HISTORY.PRODUCTS_DELETED.SALE_NAME"],
    ["operator_name", "HISTORY.PRODUCTS_DELETED.OPERATOR_NAME"],
    ["quantity_difference", "HISTORY.PRODUCTS_DELETED.QUANTITY_DIFFERENCE"],
    ["revenues", "HISTORY.PRODUCTS_DELETED.REVENUES"],
    ["room_name", "HISTORY.PRODUCTS_DELETED.ROOM_NAME"],
    ["table_name", "HISTORY.PRODUCTS_DELETED.TABLE_NAME"],
    ["covers", "HISTORY.PRODUCTS_DELETED.COVERS"],
    ["order_type", "HISTORY.PRODUCTS_DELETED.ORDER_TYPE"],
    ["lastupdate_at", "HISTORY.PRODUCTS_DELETED.LASTUPDATE_AT"],
    ["item_id", "HISTORY.PRODUCTS_DELETED.ITEM_ID"],
    ["name", "HISTORY.PRODUCTS_DELETED.NAME"],
    ["sku", "HISTORY.PRODUCTS_DELETED.SKU"],
    ["category_name", "HISTORY.PRODUCTS_DELETED.CATEGORY_NAME"],
    ["department_name", "HISTORY.PRODUCTS_DELETED.DEPARTMENT_NAME"],
    ["vat_perc", "HISTORY.PRODUCTS_DELETED.VAT_PERC"],
    ["price", "HISTORY.PRODUCTS_DELETED.PRICE"],
    ["cost", "HISTORY.PRODUCTS_DELETED.COST"]
]);

const items_showcase = new Map<keyof ItemFe | string , string>([
    ["id", "ITEMS.SHOWCASE.ID"],
    ["uuid", "ITEMS.SHOWCASE.UUID"],
    ["sku", "ITEMS.SHOWCASE.SKU"],
    ["name", "ITEMS.SHOWCASE.NAME"],
    ["description", "ITEMS.SHOWCASE.DESCRIPTION"],
    ["on_sale", "ITEMS.SHOWCASE.FOR_SALE"],
    ["is_group_item", "ITEMS.SHOWCASE.IS_GROUP_ITEM"],
    ["split_group_components", "ITEMS.SHOWCASE.SPLIT_GROUP_COMPONENTS"],
    ["index", "ITEMS.SHOWCASE.INDEX"],
    ["color", "ITEMS.SHOWCASE.COLOR"],
    ["thumbnail", "ITEMS.SHOWCASE.THUMBNAIL"],
    ["order_name", "ITEMS.SHOWCASE.ORDER_NAME"],
    ["season", "ITEMS.SHOWCASE.SEASON"],
    ["brand", "ITEMS.SHOWCASE.BRAND"],
    ["code", "ITEMS.SHOWCASE.CODE"],
    ["keyboard_code", "ITEMS.SHOWCASE.KEYBOARD_CODE"],
    ["not_discountable", "ITEMS.SHOWCASE.NOT_DISCOUNTABLE"],
    ["price1", "ITEMS.SHOWCASE.PRICE_NUMBER|value:1"],
    ["price2", "ITEMS.SHOWCASE.PRICE_NUMBER|value:2"],
    ["price3", "ITEMS.SHOWCASE.PRICE_NUMBER|value:3"],
    ["price4", "ITEMS.SHOWCASE.PRICE_NUMBER|value:4"],
    ["price5", "ITEMS.SHOWCASE.PRICE_NUMBER|value:5"],
    ["price6", "ITEMS.SHOWCASE.PRICE_NUMBER|value:6"],
    ["price7", "ITEMS.SHOWCASE.PRICE_NUMBER|value:7"],
    ["price8", "ITEMS.SHOWCASE.PRICE_NUMBER|value:8"],
    ["price9", "ITEMS.SHOWCASE.PRICE_NUMBER|value:9"],
    ["price10", "ITEMS.SHOWCASE.PRICE_NUMBER|value:10"],
    ["cost", "ITEMS.SHOWCASE.COST"],
    ["weight", "ITEMS.SHOWCASE.WEIGHT"],
    ["request_weighing", "ITEMS.SHOWCASE.REQUEST_WEIGHING"],
    ["is_frozen", "ITEMS.SHOWCASE.IS_FROZEN"],
    ["unit", "ITEMS.SHOWCASE.UNIT"],
    ["option1_value", "ITEMS.SHOWCASE.OPTION|value:1"],
    ["option2_value", "ITEMS.SHOWCASE.OPTION|value:2"],
    ["option3_value", "ITEMS.SHOWCASE.OPTION|value:3"],
    ["option4_value", "ITEMS.SHOWCASE.OPTION|value:4"],
    ["default_supplier_id", "ITEMS.SHOWCASE.SUPPLIER"],
    ["supplier_name", "ITEMS.SHOWCASE.SUPPLIER_NAME"],
    ["stock_type", "ITEMS.SHOWCASE.STOCK_TYPE"],
    ["auto_unload", "ITEMS.SHOWCASE.AUTO_UNLOAD"],
    ["manual_production", "ITEMS.SHOWCASE.MANUAL_PRODUCTION"],
    ["quantity_alert", "ITEMS.SHOWCASE.QUANTITY_ALERT"],
    ["created_at", "ITEMS.SHOWCASE.CREATED_AT"],
    ["updated_at", "ITEMS.SHOWCASE.UPDATED_AT"],
    ["createdby_id", "ITEMS.SHOWCASE.CREATED_BY_ID"],
    ["updatedby_id", "ITEMS.SHOWCASE.UPDATED_BY_ID"],
    ["item_barcodes", "ITEMS.SHOWCASE.BARCODE"],
    ["category_id", "ITEMS.SHOWCASE.CATEGORY_ID"],
    ["category_name", "ITEMS.SHOWCASE.CATEGORY_NAME"],
    ["department_id", "ITEMS.SHOWCASE.DEPARTMENT_ID|value:1"],
    ["department_name", "ITEMS.SHOWCASE.DEPARTMENT_NAME|value:1"],
    ["department2_id", "ITEMS.SHOWCASE.DEPARTMENT_ID|value:2"],
    ["department2_name", "ITEMS.SHOWCASE.DEPARTMENT_NAME|value:2"],
    ["department3_id", "ITEMS.SHOWCASE.DEPARTMENT_ID|value:3"],
    ["department3_name", "ITEMS.SHOWCASE.DEPARTMENT_NAME|value:3"],
    ["department4_id", "ITEMS.SHOWCASE.DEPARTMENT_ID|value:4"],
    ["department4_name", "ITEMS.SHOWCASE.DEPARTMENT_NAME|value:4"],
    ["department5_id", "ITEMS.SHOWCASE.DEPARTMENT_ID|value:5"],
    ["department5_name", "ITEMS.SHOWCASE.DEPARTMENT_NAME|value:5"],
    ["department6_id", "ITEMS.SHOWCASE.DEPARTMENT_ID|value:6"],
    ["department6_name", "ITEMS.SHOWCASE.DEPARTMENT_NAME|value:6"],
    ["department7_id", "ITEMS.SHOWCASE.DEPARTMENT_ID|value:7"],
    ["department7_name", "ITEMS.SHOWCASE.DEPARTMENT_NAME|value:7"],
    ["department8_id", "ITEMS.SHOWCASE.DEPARTMENT_ID|value:8"],
    ["department8_name", "ITEMS.SHOWCASE.DEPARTMENT_NAME|value:8"],
    ["department9_id", "ITEMS.SHOWCASE.DEPARTMENT_ID|value:9"],
    ["department9_name", "ITEMS.SHOWCASE.DEPARTMENT_NAME|value:9"],
    ["department10_id", "ITEMS.SHOWCASE.DEPARTMENT_ID|value:10"],
    ["department10_name", "ITEMS.SHOWCASE.DEPARTMENT_NAME|value:10"],
    ["checkout_mark", "ITEMS.SHOWCASE.CHECKOUT_MARK"],
    ["favorite", "ITEMS.SHOWCASE.FAVORITE"],
    ["Actions", "ITEMS.SHOWCASE.ACTIONS.TITLE"]
]);

const categories_showcase = new Map<keyof CategoriesFe | string, string>([
    ["id", "ITEMS.CATEGORIES.SHOWCASE.ID"],
    ["uuid", "ITEMS.CATEGORIES.SHOWCASE.UUID"],
    ["name", "ITEMS.CATEGORIES.SHOWCASE.NAME"],
    ["printer_id", "ITEMS.CATEGORIES.SHOWCASE.PRINTER_ID"],
    ["printer_name", "ITEMS.CATEGORIES.SHOWCASE.PRINTER_NAME"],
    ["terminal_id", "ITEMS.CATEGORIES.SHOWCASE.TERMINAL_ID"],
    ["terminal_name", "ITEMS.CATEGORIES.SHOWCASE.TERMINAL_NAME"],
    ["department_id", "ITEMS.CATEGORIES.SHOWCASE.DEPARTMENT_ID|value:1"],
    ["department2_id", "ITEMS.CATEGORIES.SHOWCASE.DEPARTMENT_ID|value:2"],
    ["department3_id", "ITEMS.CATEGORIES.SHOWCASE.DEPARTMENT_ID|value:3"],
    ["department4_id", "ITEMS.CATEGORIES.SHOWCASE.DEPARTMENT_ID|value:4"],
    ["department5_id", "ITEMS.CATEGORIES.SHOWCASE.DEPARTMENT_ID|value:5"],
    ["department6_id", "ITEMS.CATEGORIES.SHOWCASE.DEPARTMENT_ID|value:6"],
    ["department7_id", "ITEMS.CATEGORIES.SHOWCASE.DEPARTMENT_ID|value:7"],
    ["department8_id", "ITEMS.CATEGORIES.SHOWCASE.DEPARTMENT_ID|value:8"],
    ["department9_id", "ITEMS.CATEGORIES.SHOWCASE.DEPARTMENT_ID|value:9"],
    ["department10_id", "ITEMS.CATEGORIES.SHOWCASE.DEPARTMENT_ID|value:10"],
    ["display", "ITEMS.CATEGORIES.SHOWCASE.DISPLAY"],
    ["display_kiosk", "ITEMS.CATEGORIES.SHOWCASE.DISPLAY_KIOSK"],
    // ["display_website", "ITEMS.CATEGORIES.SHOWCASE.DISPLAY_WEBSITE"],
    ["display_slave_device", "ITEMS.CATEGORIES.SHOWCASE.DISPLAY_SLAVE_DEVICE"],
    ["department_name", "ITEMS.SHOWCASE.DEPARTMENT_NAME|value:1"],
    ["department2_name", "ITEMS.SHOWCASE.DEPARTMENT_NAME|value:2"],
    ["department3_name", "ITEMS.SHOWCASE.DEPARTMENT_NAME|value:3"],
    ["department4_name", "ITEMS.SHOWCASE.DEPARTMENT_NAME|value:4"],
    ["department5_name", "ITEMS.SHOWCASE.DEPARTMENT_NAME|value:5"],
    ["department6_name", "ITEMS.SHOWCASE.DEPARTMENT_NAME|value:6"],
    ["department7_name", "ITEMS.SHOWCASE.DEPARTMENT_NAME|value:7"],
    ["department8_name", "ITEMS.SHOWCASE.DEPARTMENT_NAME|value:8"],
    ["department9_name", "ITEMS.SHOWCASE.DEPARTMENT_NAME|value:9"],
    ["department10_name", "ITEMS.SHOWCASE.DEPARTMENT_NAME|value:10"],
    ["Actions", "ITEMS.SHOWCASE.ACTIONS.TITLE"]
])

const components_showcase = new Map<keyof ComponentsFe | string, string>([
    ["id", "ITEMS.COMPONENTS.ID"],
    ["name", "ITEMS.COMPONENTS.NAME"],
    ["price_difference", "ITEMS.COMPONENTS.PRICE_DIFFERENCE"],
    ["Actions", "ITEMS.SHOWCASE.ACTIONS.TITLE"]
])

const raw_materials_showcase = new Map<keyof RawMaterialsFe | string, string>([
    ["id", "ITEMS.RAW_MATERIALS.ID"],
    ["name", "ITEMS.RAW_MATERIALS.NAME"],
    ["quantity_alert", "ITEMS.RAW_MATERIALS.QUANTITY_ALERT"],
    ["unit", "ITEMS.RAW_MATERIALS.UNIT"],
    ["cost", "ITEMS.RAW_MATERIALS.COST"],
    ["default_supplier_id", "ITEMS.RAW_MATERIALS.SUPPLIER"],
    ["stock_type", "ITEMS.RAW_MATERIALS.ENABLE_STOCK"],
    ["auto_unload", "ITEMS.RAW_MATERIALS.AUTO_UNLOAD"],
    ["Actions", "ITEMS.SHOWCASE.ACTIONS.TITLE"]
])

const departments_showcase = new Map<keyof DepartmentsFe | string, string>([
    ["id", "ITEMS.DEPARTMENTS.ID"],
    ["name", "ITEMS.DEPARTMENTS.NAME"],
    ["printer_code", "ITEMS.DEPARTMENTS.PRINTER_CODE"],
    ["code", "ITEMS.DEPARTMENTS.CODE"],
    ["display", "ITEMS.DEPARTMENTS.DISPLAY"],
    ["pms_code", "ITEMS.DEPARTMENTS.PMS_CODE"],
    ["law_ref", "ITEMS.DEPARTMENTS.LAW_REF"],
    ["vat_id", "ITEMS.DEPARTMENTS.VAT_ID"],
    ["vat", "ITEMS.DEPARTMENTS.VAT"],
    ["activity_code_id", "ITEMS.DEPARTMENTS.ACTIVITY_CODE_ID"],
    ["activity_code", "ITEMS.DEPARTMENTS.ACTIVITY_CODE"],
    ["sales_type", "ITEMS.DEPARTMENTS.SALES_TYPE"],
    ["giftcard_type_uuid", "ITEMS.DEPARTMENTS.GIFT_CARD_TYPE"],
    ["not_discountable", "ITEMS.DEPARTMENTS.NOT_DISCOUNTABLE"],
    ["Actions", "ITEMS.SHOWCASE.ACTIONS.TITLE"]
])

const vat_rates_showcase = new Map<keyof VatRatesFe | string, string>([
    ["id", "ITEMS.VAT_RATE.ID"],
    ["value", "ITEMS.VAT_RATE.VALUE"],
    ["code", "ITEMS.VAT_RATE.CODE"],
    ["Actions", "ITEMS.SHOWCASE.ACTIONS.TITLE"]
])

const stock_showcase = new Map<keyof StockFe | string, string>([
    ["id", "STOCK.MANAGEMENT.ID"],
    ["stock_location_id", "STOCK.TOPBAR_STOCK.STOCK_LOCATION"],
    ["item_id", "STOCK.MANAGEMENT.ITEM_ID"],
    ["combination_id", "STOCK.MANAGEMENT.COMBINATION_ID"],
    ["raw_material_id", "STOCK.MANAGEMENT.RAW_MATERIAL_ID"],
    ["item_on_sale", "STOCK.MANAGEMENT.ITEM_ON_SALE"],
    ["stock_quantity", "STOCK.MANAGEMENT.STOCK"],
    ["available", "STOCK.MANAGEMENT.AVAILABILITY"],
    ["details", "STOCK.MANAGEMENT.DETAILS"],
    ["name", "STOCK.MANAGEMENT.PRODUCT"],
    ["barcode", "STOCK.MOVEMENTS.BARCODE"],
    ["code", "STOCK.MANAGEMENT.CODE"],
    ["options_values", "STOCK.MANAGEMENT.OPTIONS_VALUES"],
    ["combination", "STOCK.ADD_EDIT_MOVEMENT.COMBINATION"],
    ["lastupdate_at", "STOCK.MANAGEMENT.LAST_UPDATE"],
    ["value", "STOCK.MANAGEMENT.VALUE"],
])

const stock_movements_showcase = new Map<keyof StockMovementsFe | string, string>([
    ["date", "STOCK.MOVEMENTS.DATE"],
    ["supplier_order", "STOCK.MOVEMENTS.SUPPLIER_ORDER"],
    ["operator_fullname", "STOCK.MOVEMENTS.OPERATOR_NAME"],
    ["supplier_name", "STOCK.MOVEMENTS.SUPPLIER_NAME"],
    ["movement_type", "STOCK.MOVEMENTS.CAUSE"],
    ["Actions", "STOCK.MOVEMENTS.OPTIONS.TITLE"]
])

const stock_movements_detail = new Map<keyof StockMovementDetailFe | string, string>([
    ["name", "STOCK.NEW_MOVEMENT.NAME"],
    ["quantity", "STOCK.NEW_MOVEMENT.QUANTITY"],
    ["price", "STOCK.NEW_MOVEMENT.PRICE"],
    ["perc_discount", "STOCK.NEW_MOVEMENT.PERC_DISCOUNT"],
    ["row_amount", "STOCK.NEW_MOVEMENT.ROW_AMOUNT"],
])

const stock_movements_search = new Map<keyof StockMovementSearchFe | string, string>([
    ["name", "STOCK.NEW_MOVEMENT.NAME"],
    ["quantity", "STOCK.NEW_MOVEMENT.QUANTITY"],
    ["price", "STOCK.NEW_MOVEMENT.PRICE"],
    ["perc_discount", "STOCK.NEW_MOVEMENT.PERC_DISCOUNT"],
    ["row_amount", "STOCK.NEW_MOVEMENT.ROW_AMOUNT"],
    ["movement_type", "STOCK.MOVEMENTS.CAUSE"],
    ["date", "STOCK.MOVEMENTS.DATE"],
    ["supplier_name", "STOCK.MOVEMENTS.SUPPLIER_NAME"],
    ["supplier_order", "STOCK.MOVEMENTS.SUPPLIER_ORDER"],
])

export const headersTranslate = {
    customers_showcase,
    customers_prepaid,
    customers_fidelity,
    suppliers_showcase,
    history_sales_showcase,
    history_sales_data_sent_showcase,
    history_e_invoices_showcase,
    giftcard_showcase,
    settings_um_static_token,
    history_cash_movements,
    file_importer,
    file_exporter,
    promotions_showcase,
    history_products_deleted,
    items_showcase,
    categories_showcase,
    components_showcase,
    raw_materials_showcase,
    departments_showcase,
    vat_rates_showcase,
    stock_showcase,
    stock_movements_showcase,
    stock_movements_detail,
    stock_movements_search
};
